const addPictureLikeCounts = (currentPicturesLikesCounts, newPictures) => {
  const currentPicturesLikesCountsCopy = Object.assign({}, currentPicturesLikesCounts);
  const newPicturesLikesCounts = {};
  newPictures.forEach(picture => newPicturesLikesCounts[picture.id] = picture.likeCount);
  return Object.assign(currentPicturesLikesCountsCopy, newPicturesLikesCounts);
};

export default addPictureLikeCounts;
